import BufferConflict from "@/assets/icons/attendees/bufferConflict.svg";
import BufferSelected from "@/assets/icons/attendees/bufferSelected.svg";
import BufferTime from "@/assets/icons/attendees/bufferTime.svg";
import NoInformation from "@/assets/icons/attendees/noInformation.svg";
import { Rect } from "react-konva";
import useImage from "use-image";
import { IStatusProps } from "./Models";


import { EventBufferEnum } from "../Models";
import { BufferEnd } from "./BufferEnd";
import { BufferStart } from "./BufferStart";


export const BufferTimeStatus = ({
  x,
  widthState,
  heightState,
  totalTile,
  height,
  strokeWidth,
  bufferStatus,
  preBufferTime,
  postBufferTime,
  bufferTimeText,
  minutesText,
  isSelected,
  isConflict,
  isHover,
}: IStatusProps): JSX.Element => {
  //console.log(isSelected && !isConflict);

  const [image] = useImage(isSelected && !isConflict ? BufferSelected : isConflict ? BufferConflict : BufferTime || "");

  const renderBuffer = () => {
    let _returnBuffer;
    if (bufferStatus === EventBufferEnum.Buffer) {
      _returnBuffer = (
        <>
          <BufferStart
            x={x}
            totalTile={totalTile}
            widthState={widthState}
            heightState={heightState}
            height={height}
            strokeWidth={strokeWidth || 0}
            preBufferTime={preBufferTime}
            bufferTimeText={bufferTimeText || ""}
            minutesText={minutesText || ""}
            image={image}
            isSelected={isSelected}
            stroke={isSelected && !isConflict ? "rgba(53, 179, 73, 1)" : isConflict ? "rgba(196, 49, 75, 1)" : "rgba(87, 127, 180, 1)"}
            bufferStatus={bufferStatus}
            isConflict={isConflict}
            isHover={isHover}
          />

          <BufferEnd
            x={x}
            totalTile={totalTile}
            postBufferTime={postBufferTime}
            widthState={widthState}
            heightState={heightState}
            height={height}
            strokeWidth={strokeWidth || 0}
            bufferTimeText={bufferTimeText || ""}
            minutesText={minutesText || ""}
            image={image}
            isSelected={isSelected}
            stroke={isSelected && !isConflict ? "rgba(53, 179, 73, 1)" : isConflict ? "rgba(196, 49, 75, 1)" : "rgba(87, 127, 180, 1)"}
            bufferStatus={bufferStatus}
            isConflict={isConflict}
            isHover={isHover}
          />
        </>
      );
    } else if (bufferStatus === EventBufferEnum.BufferStart) {
      _returnBuffer = (
        <BufferStart
          x={x}
          totalTile={totalTile}
          widthState={widthState}
          heightState={heightState}
          height={height}
          strokeWidth={strokeWidth || 0}
          preBufferTime={preBufferTime}
          bufferTimeText={bufferTimeText || ""}
          minutesText={minutesText || ""}
          image={image}
          isSelected={isSelected}
          stroke={isSelected && !isConflict ? "rgba(53, 179, 73, 1)" : isConflict ? "rgba(196, 49, 75, 1)" : "rgba(87, 127, 180, 1)"}
          bufferStatus={bufferStatus}
          isConflict={isConflict}
          isHover={isHover}
        />
      );
    } else if (bufferStatus === EventBufferEnum.BufferEnd) {
      _returnBuffer = (
        <BufferEnd
          x={x}
          totalTile={totalTile}
          postBufferTime={postBufferTime}
          widthState={widthState}
          heightState={heightState}
          height={height}
          strokeWidth={strokeWidth || 0}
          bufferTimeText={bufferTimeText || ""}
          minutesText={minutesText || ""}
          image={image}
          isSelected={isSelected}
          stroke={isSelected && !isConflict ? "rgba(53, 179, 73, 1)" : isConflict ? "rgba(196, 49, 75, 1)" : "rgba(87, 127, 180, 1)"}
          bufferStatus={bufferStatus}
          isConflict={isConflict}
          isHover={isHover}
        />
      );
    } else {
      _returnBuffer = null; // hoặc có thể trả về một component khác để hiển thị khi không có buffer
    }

    return _returnBuffer;
  };

  return <>{renderBuffer()}</>;
};

export const NoInformationStatus = (props: IStatusProps): JSX.Element => {
  const [image] = useImage(NoInformation);
  return (
    <Rect
      x={props.x}
      y={props.heightState - props.height + 2}
      width={props.widthState}
      height={props.height}
      stroke="#BDBDBD"
      // strokeWidth={strokeWidth}
      fillPatternImage={image}
    />
  );
};
